import { EventType } from '@/analytics/types';
import type { FooterCtaProps } from '@/app/components/FooterCta';
import FooterCta from '@/app/components/FooterCta';
import type { FooterCtaImageProps } from '@/app/components/FooterCta/FooterCtaImage';

const PartnershipsFooter = () => {
  const handleFooterCtaClick = () => {
    const pathname = new URL('https://partners.ouraring.com/');

    void window.ouraAnalytics.track(EventType.LinkClicked, {
      cta: 'request_a_demo',
      location: 'partnerships footer',
      path: pathname,
    });

    window.open(pathname, '_blank');
  };

  const variant: FooterCtaProps['variant'] = {
    sm: 'two_column',
    lg: 'two_column',
  };

  const image: FooterCtaImageProps['image'] = {
    src: 'partnerships/footer.jpg?fit=crop&crop=focalpoint&fp-x=0.55&fp-y=0.47&fp-z=1.4',
    localizedAlt: 'partnerships_footer_image_alt',
  };
  return (
    <section
      className="mt-12 max-lg:pb-4 lg:py-28"
      data-cy="partnerships-footer"
    >
      <FooterCta
        buttons={[
          {
            label: 'partnerships_footer_action',
            variant: 'secondary-dark',
            onClick: handleFooterCtaClick,
          },
        ]}
        className="text-sandstone-500"
        indentation="lg:pl-20"
        image={image}
        inverted
        imageClassName="md:h-[600px]"
        title="partnerships_footer_copy"
        variant={variant}
      />
    </section>
  );
};

export default PartnershipsFooter;
